import React from "react";
import { FaRegBookmark } from "react-icons/fa";
import { CiCalendar } from "react-icons/ci";
import { CiYoutube } from "react-icons/ci";
import { IoWalletOutline } from "react-icons/io5";
import { MdOutlineReportProblem } from "react-icons/md";
import { PiMicrophoneStage } from "react-icons/pi";
import { BsLaptop } from "react-icons/bs";

function AboutBootcamp() {
  return (
    <div className="container my-5">
      <div className="row g-5">
        <div className="col-lg-7">
          <h1 className="fw-bold mb-4" style={{ color: "#1a1a2e" }}>About BootCamp</h1>
          <p className="about-bootcamp-content mb-4">
            DataCode's 30-Day Bootcamps are live, mentor-led programs
            designed to equip you with practical, job-ready skills.
            Whether you are mastering UI/UX design, diving into Full Stack 
            Web Development, or strengthening your Data Structures & Algorithms,
            our curriculum is built around daily hands-on practice, industry standards,
            and personalized feedback to help you succeed in the tech landscape.
          </p>
        </div>
        <div className="col-lg-5">
          <div className="p-4 rounded shadow-sm" style={{ border: "1px solid #eee", background: "#fff" }}>
            <h5 className="fw-bold mb-3" style={{ color: "#1a1a2e" }}>30 Days Of UI/UX BootCamp</h5>
            <div className="about-list mb-3">
              <div className="list-itmes">
                <FaRegBookmark className="icon" />
                <span>Certificate of Participation</span>
              </div>
              <div className="list-itmes">
                <CiCalendar className="icon" />
                <span>Exclusive Courses</span>
              </div>
              <div className="list-itmes">
                <CiYoutube className="icon" />
                <span>Lifetime Access</span>
              </div>
            </div>
            <div className="about-container-row mb-0" style={{ borderBottom: "none" }}>
              <div className="d-flex align-items-center">
                <IoWalletOutline className="icon mr-2" style={{ color: "#6f42c1", fontSize: "1.5rem" }} />
                <span className="price" style={{ margin: 0 }}>₹149</span>
              </div>
              <button className="btn btn-primary text-white">Enroll Now</button>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-5">
        <h5 className="fw-bold mb-3" style={{ color: "#1a1a2e" }}>Key Features</h5>
        <div className="about-grid-container">
          <div className="about-grid-item">
            <div className="about-flex-container">
              <div className="about-icon-container">
                <CiYoutube className="about-icon" />
              </div>
              <div className="about-text-container">
                <span className="label">Duration</span>
                <span className="val">30 Days</span>
              </div>
            </div>
          </div>
          <div className="about-grid-item">
            <div className="about-flex-container">
              <div className="about-icon-container">
                <MdOutlineReportProblem className="about-icon" />
              </div>
              <div className="about-text-container">
                <span className="label">Problems</span>
                <span className="val">30 Problems</span>
              </div>
            </div>
          </div>
          <div className="about-grid-item">
            <div className="about-flex-container">
              <div className="about-icon-container">
                <PiMicrophoneStage className="about-icon" />
              </div>
              <div className="about-text-container">
                <span className="label">Module</span>
                <span className="val">10 Lessons</span>
              </div>
            </div>
          </div>
          <div className="about-grid-item">
            <div className="about-flex-container">
              <div className="about-icon-container">
                <BsLaptop className="about-icon" />
              </div>
              <div className="about-text-container">
                <span className="label">Projects</span>
                <span className="val">5+ Projects</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AboutBootcamp;
